import React from "react";
import Container from "../../components/Container";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import BannerBand from "../../svgs/banner-band.svg";
import { Desktop, Tablet } from "../../constants/responsive";
import { css } from "@emotion/core";
import { useIntl } from "gatsby-plugin-intl";

const GeneralBanner = ({ children }) => {
  const intl = useIntl();
  const imageLocale = intl.locale
    .split("-")
    .map((code) => code[0].toUpperCase() + code[1])
    .join("");
  const data = useStaticQuery(graphql`
    query {
      En: file(relativePath: { eq: "home-banner/1-en.png" }) {
        childImageSharp {
          fluid(maxWidth: 735) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ZhCn: file(relativePath: { eq: "home-banner/1-zh-cn.png" }) {
        childImageSharp {
          fluid(maxWidth: 735) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ZhHk: file(relativePath: { eq: "home-banner/1-zh-hk.png" }) {
        childImageSharp {
          fluid(maxWidth: 735) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  return (
    <>
      <div
        css={css`
          background: #f2f2f2;
          width: 100%;
          height: 235px;
          display: flex;
          justify-content: center;
          position: relative;
          ${Tablet} {
            height: 180px;
          }
          ${Desktop} {
            height: 255px;
          }
        `}
      >
        <div
          css={css`
            position: absolute;
            width: 420px;
            transform: translate(20%, -42%);
            ${Tablet} {
              width: 420px;
              transform: translate(40%, -42%);
            }
            ${Desktop} {
              width: 735px;
              transform: translate(35%, -45%);
            }
          `}
        >
          <Img
            fluid={data[imageLocale].childImageSharp.fluid}
            imgStyle={{ objectFit: "fill" }}
            loading="eager"
          />
        </div>
        <Container
          css={css`
            z-index: 1;
          `}
        >
          <div
            css={css`
              padding-top: 115px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-direction: column;
              ${Tablet} {
                padding-top: 80px;
              }
              ${Desktop} {
                padding-top: 120px;
              }
              /* 某些小屏幕的设备中title可能过长挡住了背景图，让这些设备中title最后一个单词下移，显示背景图 */
              @media (min-width:361px) and (max-width:767px){
                max-width:206px;
              }
            `}
          >
            <h1>{children}</h1>
          </div>
        </Container>
      </div>
      <div
        css={css`
          height: 25px;
          width: 100%;
          min-width: 320px;
          ${Tablet} {
            height: 40px;
          }
          ${Desktop} {
            height: 70px;
          }
        `}
      >
        <BannerBand width="100%" height="100%" />
      </div>
    </>
  );
};

export default GeneralBanner;
